import { Menu } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom";
import "./layout.scss";
import "./sidebar.scss";

function Sidebar(props) {
  const [search, setSearch] = useState("");
  const [openKeys, setOpenKeys] = useState([]);
  const [listMenu, setListMenu] = useState([]);
  const [defaulfKeyOpen, setDefaulfKeyOpen] = useState([]);
  const [menuPathMap, setMenuPathMap] = useState({});
  const [selectedKeys, setSelectedKeys] = useState([]);
  const menusImmutable = useSelector((state) => state.menuReducer.get("menus"));

  const menusSelector = useMemo(() => {
    return menusImmutable ? menusImmutable.toJS() : [];
  }, [menusImmutable]);
  const location = useLocation();

  // Mock data với sections
  const mockMenuData = [
    // === SECTIONS ===
    {
      id: 100,
      name: "Main",
      icon: null,
      path: null,
      order: 1,
      active: true,
      parent_id: null,
      section_id: null,
      is_section: true,
      roles: "1,2,3,4,5,6",
    },
    {
      id: 101,
      name: "Kho",
      icon: null,
      path: null,
      order: 2,
      active: true,
      parent_id: null,
      section_id: null,
      is_section: true,
      roles: "1,2,3,4,6",
    },
    {
      id: 102,
      name: "Báo cáo",
      icon: null,
      path: null,
      order: 3,
      active: true,
      parent_id: null,
      section_id: null,
      is_section: true,
      roles: "1,6,4",
    },
    {
      id: 103,
      name: "Hệ thống",
      icon: null,
      path: null,
      order: 4,
      active: true,
      parent_id: null,
      section_id: null,
      is_section: true,
      roles: "1,2,3,4,5,6",
    },
    // === MAIN SECTION ===
    {
      id: 1,
      name: "Dashboard",
      icon: "bi bi-speedometer2",
      path: "/dashboard",
      order: 1,
      active: true,
      parent_id: null,
      section_id: 100,
      is_section: false,
      roles: "1,2,3,4,5,6",
    },
    {
      id: 2,
      name: "Quản lý đơn hàng",
      icon: "bi bi-cart-check",
      path: null,
      order: 2,
      active: true,
      parent_id: null,
      section_id: 100,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 3,
      name: "Danh sách đơn hàng",
      icon: "bi bi-receipt",
      path: "/orders/list",
      order: 1,
      active: true,
      parent_id: 2,
      section_id: 100,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 20,
      name: "Quản lý ký gửi",
      icon: "bi bi-archive",
      path: null,
      order: 3,
      active: true,
      parent_id: null,
      section_id: 100,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 21,
      name: "Danh sách ký gửi",
      icon: "bi bi-inbox",
      path: "/consignment/list",
      order: 1,
      active: true,
      parent_id: 20,
      section_id: 100,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 30,
      name: "Ký gửi chiều",
      icon: "bi bi-arrow-right",
      path: "/consignment-directions/list",
      order: 2,
      active: true,
      parent_id: 20,
      section_id: 100,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 22,
      name: "Khách hàng",
      icon: "bi bi-people",
      path: null,
      order: 4,
      active: true,
      parent_id: null,
      section_id: 100,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 23,
      name: "Danh sách admin",
      icon: "bi bi-shield-person",
      path: "/system/users",
      order: 1,
      active: true,
      parent_id: 22,
      section_id: 100,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 34,
      name: "Danh sách khách hàng",
      icon: "bi bi-person-badge",
      path: "/system/users",
      order: 2,
      active: true,
      parent_id: 22,
      section_id: 100,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    // === KHO SECTION ===
    {
      id: 7,
      name: "Kho Quốc Tế",
      icon: "bi bi-globe-americas",
      path: "/warehouse/international",
      order: 1,
      active: true,
      parent_id: null,
      section_id: 101,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 8,
      name: "Kho Việt Nam",
      icon: "bi bi-house-door",
      path: "/warehouse/vn",
      order: 2,
      active: true,
      parent_id: null,
      section_id: 101,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 9,
      name: "Nhập vận đơn",
      icon: "bi bi-upload",
      path: "/tracking-number",
      order: 1,
      active: true,
      parent_id: 7,
      section_id: 101,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 10,
      name: "Quản lý vận đơn",
      icon: "bi bi-clipboard-data",
      path: "/warehouse/tracking-manager",
      order: 2,
      active: true,
      parent_id: 7,
      section_id: 101,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 25,
      name: "Quản lý bao",
      icon: "bi bi-boxes",
      path: "/package",
      order: 3,
      active: true,
      parent_id: 7,
      section_id: 101,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 19,
      name: "Nhập vận đơn nội địa",
      icon: "bi bi-file-earmark-plus",
      path: "/tracking-number-local",
      order: 1,
      active: true,
      parent_id: 8,
      section_id: 101,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 18,
      name: "Quản lý vận đơn nội địa",
      icon: "bi bi-box-seam",
      path: "/warehouse/warehouse-local",
      order: 2,
      active: true,
      parent_id: 8,
      section_id: 101,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 17,
      name: "Quản lý phiếu xuất kho",
      icon: "bi bi-file-earmark-arrow-up",
      path: "/warehouse/receipt-list",
      order: 3,
      active: true,
      parent_id: 8,
      section_id: 101,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    {
      id: 29,
      name: "Yêu cầu giao",
      icon: "bi bi-truck",
      path: "/warehousevn/delivery",
      order: 4,
      active: true,
      parent_id: 8,
      section_id: 101,
      is_section: false,
      roles: "1,2,3,4,6",
    },
    // === BÁO CÁO SECTION ===
    {
      id: 12,
      name: "Tài chính",
      icon: "bi bi-cash-stack",
      path: null,
      order: 1,
      active: true,
      parent_id: null,
      section_id: 102,
      is_section: false,
      roles: "1,6,4",
    },
    {
      id: 13,
      name: "Thanh toán",
      icon: "bi bi-credit-card",
      path: "/finance/payments",
      order: 1,
      active: true,
      parent_id: 12,
      section_id: 102,
      is_section: false,
      roles: "1,6,4",
    },
    {
      id: 28,
      name: "Lịch sử giao dịch",
      icon: "bi bi-clock-history",
      path: "/finance/history",
      order: 2,
      active: true,
      parent_id: 12,
      section_id: 102,
      is_section: false,
      roles: "1,6,4",
    },
    {
      id: 14,
      name: "Báo cáo doanh thu",
      icon: "bi bi-graph-up-arrow",
      path: null,
      order: 1,
      active: true,
      parent_id: null,
      section_id: 102,
      is_section: false,
      roles: "1,6,4",
    },
    {
      id: 30,
      name: "Thống kê mua hàng",
      icon: "bi bi-cart-check",
      path: "/report/purchase-statistics",
      order: 1,
      active: true,
      parent_id: 14,
      section_id: 102,
      is_section: false,
      roles: "1,6,4",
    },
    {
      id: 31,
      name: "Thống kê ký gửi",
      icon: "bi bi-box-seam",
      path: "/report/consignment-statistics",
      order: 2,
      active: true,
      parent_id: 14,
      section_id: 102,
      is_section: false,
      roles: "1,6,4",
    },
    {
      id: 32,
      name: "Thống kê bán hàng",
      icon: "bi bi-bag-check",
      path: "/report/sale-statistics",
      order: 3,
      active: true,
      parent_id: 14,
      section_id: 102,
      is_section: false,
      roles: "1,6,4",
    },
    // === HỆ THỐNG SECTION ===
    {
      id: 15,
      name: "Quản lý menu",
      icon: "bi bi-list-nested",
      path: "/system/menus",
      order: 1,
      active: true,
      parent_id: null,
      section_id: 103,
      is_section: false,
      roles: "1,2,3,4,5,6",
    },
    {
      id: 16,
      name: "Quản trị người dùng",
      icon: "bi bi-person-gear",
      path: "/profile",
      order: 2,
      active: true,
      parent_id: null,
      section_id: 103,
      is_section: false,
      roles: "1,2,3,4,5,6",
    },
    {
      id: 29,
      name: "Tham số hệ thống",
      icon: "bi bi-list-nested",
      path: "/system/settings",
      order: 3,
      active: true,
      parent_id: null,
      section_id: 103,
      is_section: false,
      roles: "1,2,3,4,5,6",
    },
    {
      id: 45,
      name: "Bảng phí cọc",
      icon: "bi bi-wallet2",
      path: "/system/despositfee",
      order: 4,
      active: true,
      parent_id: null,
      section_id: 103,
      is_section: false,
      roles: "1,2,3,4,5,6",
    },
    {
      id: 46,
      name: "Bảng phí mua hàng",
      icon: "bi bi-cart4",
      path: "/system/purchasefee",
      order: 5,
      active: true,
      parent_id: null,
      section_id: 103,
      is_section: false,
      roles: "1,2,3,4,5,6",
    },
    {
      id: 48,
      name: "Tỷ giá ngoại tệ",
      icon: "bi bi-currency-exchange",
      path: "/system/rate",
      order: 6,
      active: true,
      parent_id: null,
      section_id: 103,
      is_section: false,
      roles: "1,2,3,4,5,6",
    },
    {
      id: 49,
      name: "Nhà cung cấp",
      icon: "bi bi-shop",
      path: "/system/provider",
      order: 7,
      active: true,
      parent_id: null,
      section_id: 103,
      is_section: false,
      roles: "1,2,3,4,5,6",
    },
    {
      id: 50,
      name: "Phí phụ thu",
      icon: "bi bi-coin",
      path: "/system/surcharge-types",
      order: 8,
      active: true,
      parent_id: null,
      section_id: 103,
      is_section: false,
      roles: "1,2,3,4,5,6",
    },
    {
      id: 47,
      name: "Bảng phí cân nặng",
      icon: "bi bi-speedometer",
      path: "/system/weightfee",
      order: 8,
      active: true,
      parent_id: null,
      section_id: 103,
      is_section: false,
      roles: "1,2,3,4,5,6",
    },
    {
      id: 51,
      name: "Tài khoản ngân hàng",
      icon: "bi bi-bank",
      path: "/system/bank-account",
      order: 9,
      active: true,
      parent_id: null,
      section_id: 103,
      is_section: false,
      roles: "1,2,3,4,5,6",
    },
  ];
  const rootKeys = ["2", "3"]; // key của menu cha cấp 1
  const handleOpenChange = (keys) => {
    const latestKey = keys.find((key) => !openKeys.includes(key));

    if (rootKeys.includes(latestKey)) {
      setOpenKeys(latestKey ? [latestKey] : []);
    } else {
      setOpenKeys(keys);
    }
  };

  // Xử lý click menu - reload nếu click vào trang hiện tại
  const handleMenuClick = ({ key }) => {
    const path = menuPathMap[key];
    if (path && location.pathname === path) {
      window.location.reload();
    }
    // Call parent callback to close sidebar on mobile
    if (props.onMenuClick) {
      props.onMenuClick();
    }
  };

  // Build menu tree cho các item trong một section
  const buildMenuTree = (menuData, parentKey = null, sectionId = null) => {
    return menuData
      .filter(
        (item) =>
          !item.is_section &&
          item.parent_id === parentKey &&
          item.section_id === sectionId
      )
      .sort((a, b) => a.order - b.order)
      .map((item) => {
        const children = buildMenuTree(menuData, item.id, sectionId);
        return {
          key: item.id.toString(),
          icon: item.icon ? <i className={item.icon}></i> : null,
          label: item.path ? (
            <Link
              style={{ textDecoration: "none", color: "currentColor" }}
              to={item.path}
            >
              {item.name}
            </Link>
          ) : (
            item.name
          ),
          children: children.length > 0 ? children : undefined,
        };
      });
  };

  // Build menu với sections
  const buildMenuWithSections = (menuData) => {
    // Lấy tất cả sections
    const sections = menuData
      .filter((item) => item.is_section)
      .sort((a, b) => a.order - b.order);

    const menuItems = [];

    sections.forEach((section) => {
      // Thêm section header (type: group)
      const sectionItems = buildMenuTree(menuData, null, section.id);

      if (sectionItems.length > 0) {
        menuItems.push({
          key: `section-${section.id}`,
          label: section.name,
          type: "group",
          children: sectionItems,
        });
      }
    });

    return menuItems;
  };

  useEffect(() => {
    // Sử dụng data từ redux nếu có, nếu không thì dùng mockMenuData
    const menuData =
      menusSelector && menusSelector.length > 0 ? menusSelector : [];
    // const menuData = mockMenuData;
    // Kiểm tra xem data có chứa sections không
    const hasSections = menuData.some((item) => item.is_section);
    if (hasSections) {
      setListMenu(buildMenuWithSections(menuData));
    } else {
      // Fallback cho data cũ không có sections
      setListMenu(buildMenuTree(menuData));
    }

    // Build map key -> path để xử lý reload
    const pathMap = {};
    menuData.forEach((item) => {
      if (item.path) {
        pathMap[item.id.toString()] = item.path;
      }
    });
    setMenuPathMap(pathMap);

    // Set selected key dựa trên URL hiện tại
    const currentPath = location.pathname;
    const activeItem = menuData.find((item) => item.path === currentPath);
    if (activeItem) {
      setSelectedKeys([activeItem.id.toString()]);
      // Nếu menu item có parent, mở parent menu
      if (activeItem.parent_id) {
        setOpenKeys([activeItem.parent_id.toString()]);
      }
    }
  }, [menusSelector, location.pathname]);
  console.log(menusSelector);

  return (
    <div>
      {/*Sidebar Brand*/}
      <div className="sidebar-brand">
        {/*Brand Link*/}
        <a href="#" className="brand-link">
          {/*Brand Image*/}
          <img
            style={{ width: "90px" }}
            src="/assets/img/logo/logotv.png"
            alt="logo"
            className="logo"
          />
          {/*Brand Image*/}
          {/*Brand Text*/}
          {/* <span className="brand-text fw-light">Tre Việt</span> */}
          {/*Brand Text*/}
        </a>
        {/*Brand Link*/}
      </div>
      {/*Sidebar Brand*/}
      {/*Sidebar Wrapper*/}
      <div className="sidebar-wrapper">
        <nav className="mt-2">
          <Menu
            mode="inline"
            items={listMenu}
            className="custom-menu"
            openKeys={openKeys}
            onOpenChange={handleOpenChange}
            onClick={handleMenuClick}
            selectedKeys={selectedKeys}
          />
          {/*Sidebar Menu*/}
        </nav>
      </div>
      {/*Sidebar Wrapper*/}
    </div>
  );
}
export default Sidebar;
